{
  "incidentsOverview": {
    "button": {
      "new": "",
      "columns": "",
      "download": ""
    },
    "tooltip": {
      "edit": "",
      "preview": ""
    },
    "empty": "",
    "loading": "",
    "error": "",
    "retry": "",
    "filter": {
      "anyStatus": ""
    }
  },
  "incidentReportUI": {
    "addAttachment": "",
    "addAvalancheProblem": "",
    "addGroup": "",
    "addVictim": "",
    "back": "Endarrere",
    "clearLine": "",
    "clearPoint": "",
    "clearPolygon": "",
    "controls": "",
    "deleteIncident": "",
    "deleteIncidentConfirm": "",
    "drawLine": "",
    "drawLineInstructions": "",
    "drawPoint": "",
    "drawPointInstructions": "",
    "drawPolygon": "",
    "drawPolygonInstructions": "",
    "dropAttachment": "",
    "dropAvalancheProblem": "",
    "dropGroup": "",
    "dropVictim": "",
    "fetchPublishedBulletin": "",
    "fetchPublishedBulletinError": "",
    "fetchPublishedBulletinSuccess": "",
    "groupName": "",
    "groupUnknown": "",
    "incomplete": "Incomplèt",
    "line": "",
    "locationMap": "",
    "noGroups": "",
    "next": "Següent",
    "overview": "",
    "noVictims": "",
    "point": "",
    "polygon": "",
    "publishIncident": "Publicar",
    "publishIncidentConfirm": "",
    "publishIncidentSuccess": "",
    "republishIncident": "",
    "republishIncidentConfirm": "",
    "unpublishIncident": "",
    "unpublishIncidentConfirm": "",
    "unpublishIncidentSuccess": "",
    "removeAttachment": "",
    "removeAvalancheProblem": "",
    "removeGroup": "",
    "removeVictim": "",
    "requiredFieldsMissingHint": "",
    "displayMode": {
      "edit": "Editar",
      "editMostRelevant": "",
      "all": "",
      "public": "",
      "filledOut": ""
    },
    "victimName": "",
    "saveStateSaving": "",
    "saveStateSaved": "",
    "saveStateError": "",
    "saveStateBlocked": ""
  },
  "incidentReport": {
    "incidentReport": "",
    "metaInformation": "",
    "generalInformation": "",
    "bulletinInformation": "",
    "locationInformation": "",
    "avalancheInformation": "",
    "groupInformation": "",
    "victimInformation": "",
    "involvementsFatalitiesBurials": "",
    "incidentAnalysis": "",
    "incidentAttachments": "",
    "author": "Autor",
    "authorAffiliation": "",
    "dateTime": "",
    "updatedAt": "",
    "publishedAt": "",
    "timeAccuracy": "",
    "sourceOfInformation": "",
    "personInvolvement": "",
    "otherDamages": "",
    "damagedAssets": "",
    "otherDamagesComment": "",
    "publicAvalancheWarningService": "",
    "publicAvalancheWarningServiceOutside": "",
    "dangerRating": "Grad de perilh",
    "avalancheProblem": "Problèma de lauegi",
    "problemType": "Problèma de lauegi",
    "aspects": "Orientacions",
    "elevationLowerBound": "Banda de nautada inferiora",
    "elevationUpperBound": "Banda de nautada superiora",
    "snowpackStability": "Estabilitat deth celh de nhèu",
    "frequency": "Frecuéncia",
    "dangerPattern": "Patron de perilh",
    "reportStatus": "",
    "publicExternalLinks": "",
    "privateExternalLinks": "",
    "privateExternalDatabaseLinks": "",
    "generalInformationComment": "",
    "bulletinInformationComment": "",
    "location": "Localitat",
    "country": "",
    "region": "",
    "municipality": "",
    "avalancheRegion": "",
    "latitude": "Latitud",
    "longitude": "Longitud",
    "locationAccuracy": "",
    "lineCoordinatesText": "",
    "polygonCoordinatesText": "",
    "locationInformationComment": "",
    "locationType": {
      "Point": "",
      "Line": "",
      "Polygon": ""
    },
    "anonymousGroupIdentifier": "",
    "groupAffiliation": "",
    "groupType": "",
    "groupSize": "",
    "groupSizeAccuracy": "",
    "incidentTerrainType": "",
    "typeOfControlledTerrain": "",
    "incidentActivity": "",
    "travelDirection": "",
    "vehicleType": "",
    "avalancheGear": "",
    "groupInformationComment": "",
    "numberOfGroups": "",
    "activities": "",
    "terrainTypes": "",
    "fatalities": "",
    "injuredSurvivors": "",
    "uninjuredSurvivors": "",
    "caughtOnly": "",
    "fullyBuried": "",
    "partlyBuriedHeadCovered": "",
    "partlyBuriedHeadUncovered": "",
    "partlyBuried": "",
    "numberInvolved": "",
    "involvementsFatalitiesBurialsComment": "",
    "caught": "",
    "fatalInjured": "",
    "burialDegree": "",
    "anonymousVictimIdentifier": "",
    "age": "",
    "gender": "",
    "workingAtTime": "",
    "leaderAtTime": "",
    "professionalCertification": "",
    "avalancheTraining": "",
    "yearsActive": "",
    "transceiver": "",
    "shovel": "",
    "probe": "",
    "airbag": "",
    "helmet": "",
    "terrainTrap": "",
    "burialDepth": "",
    "burialDuration": "",
    "primaryLocationMethod": "",
    "rescuedBy": "",
    "medicalIntervention": "",
    "estimatedTimeOfDeath": "",
    "causeOfDeath": "",
    "respiratoryCavity": "",
    "injurySeverity": "",
    "victimInformationComment": "",
    "multipleAvalanches": "",
    "avalancheSize": "Mida de lauet",
    "avalancheType": "",
    "relevantAvalancheProblem": "",
    "trigger": "",
    "natural": "",
    "person": "",
    "additionalLoad": "",
    "explosives": "",
    "vehicle": "",
    "accidentalControlled": "",
    "remoteTriggering": "",
    "startZoneAspect": "",
    "startZoneAspectAccuracy": "",
    "startZoneElevation": "",
    "startZoneElevationAccuracy": "",
    "startZoneIncline": "",
    "startZoneTerrainType": "",
    "slabWidth": "",
    "crownDepthAvg": "",
    "crownDepthMin": "",
    "crownDepthMax": "",
    "avalancheLength": "Avalanche Lenght",
    "weakLayerName": "",
    "weakLayerGrainType1": "",
    "weakLayerGrainSize1": "",
    "weakLayerGrainType2": "",
    "weakLayerGrainSize2": "",
    "weakLayerLocation": "",
    "bedSurfaceStepped": "",
    "startZoneMoisture": "",
    "depositMoisture": "",
    "depositHeight": "",
    "depositWidth": "",
    "debrisType": "",
    "debrisDensity": "",
    "depositElevation": "",
    "avalancheDetailsComment": "",
    "incidentLedePublic": "",
    "incidentLede": "",
    "incidentDescriptionPublic": "",
    "incidentDescription": "",
    "weatherDescriptionPublic": "",
    "weatherDescription": "",
    "avalancheDescriptionPublic": "",
    "avalancheDescription": "",
    "snowpackDescriptionPublic": "",
    "snowpackDescription": "",
    "takeAwaysPublic": "",
    "takeAways": "",
    "recentSlabAvalanches": "",
    "signsOfInstability": "",
    "recentLoading": "",
    "criticalWarming": "",
    "incidentAnalysisComment": "",
    "uuid": "",
    "dateAdded": "",
    "dateCreated": "",
    "file": "",
    "fileName": "",
    "mediaType": "",
    "attachmentTags": "",
    "altText": "",
    "credit": "",
    "caption": "",
    "public": "",
    "attachmentCategory": ""
  },
  "incidentReportHelp": {
    "author": "",
    "authorAffiliation": "",
    "dateTime": "",
    "timeAccuracy": "",
    "sourceOfInformation": "",
    "personInvolvement": "",
    "otherDamages": "",
    "damagedAssets": "",
    "otherDamagesComment": "",
    "publicAvalancheWarningService": "",
    "publicAvalancheWarningServiceOutside": "",
    "dangerRating": "",
    "avalancheProblem": "",
    "problemType": "",
    "aspects": "",
    "elevationLowerBound": "",
    "elevationUpperBound": "",
    "snowpackStability": "",
    "frequency": "",
    "dangerPattern": "",
    "reportStatus": "",
    "publicExternalLinks": "",
    "privateExternalLinks": "",
    "privateExternalDatabaseLinks": "",
    "generalInformationComment": "",
    "bulletinInformationComment": "",
    "location": "",
    "country": "",
    "region": "",
    "municipality": "",
    "avalancheRegion": "",
    "latitude": "",
    "longitude": "",
    "locationAccuracy": "",
    "lineCoordinatesText": "",
    "polygonCoordinatesText": "",
    "locationInformationComment": "",
    "anonymousGroupIdentifier": "",
    "groupAffiliation": "",
    "groupType": "",
    "groupSize": "",
    "groupSizeAccuracy": "",
    "incidentTerrainType": "",
    "typeOfControlledTerrain": "",
    "incidentActivity": "",
    "travelDirection": "",
    "vehicleType": "",
    "avalancheGear": "",
    "groupInformationComment": "",
    "numberOfGroups": "",
    "activities": "",
    "terrainTypes": "",
    "fatalities": "",
    "injuredSurvivors": "",
    "uninjuredSurvivors": "",
    "caughtOnly": "",
    "fullyBuried": "",
    "partlyBuriedHeadCovered": "",
    "partlyBuriedHeadUncovered": "",
    "partlyBuried": "",
    "numberInvolved": "",
    "involvementsFatalitiesBurialsComment": "",
    "caught": "",
    "fatalInjured": "",
    "burialDegree": "",
    "anonymousVictimIdentifier": "",
    "age": "",
    "gender": "",
    "workingAtTime": "",
    "leaderAtTime": "",
    "professionalCertification": "",
    "avalancheTraining": "",
    "yearsActive": "",
    "transceiver": "",
    "shovel": "",
    "probe": "",
    "airbag": "",
    "helmet": "",
    "terrainTrap": "",
    "burialDepth": "",
    "burialDuration": "",
    "primaryLocationMethod": "",
    "rescuedBy": "",
    "medicalIntervention": "",
    "estimatedTimeOfDeath": "",
    "causeOfDeath": "",
    "respiratoryCavity": "",
    "injurySeverity": "",
    "victimInformationComment": "",
    "multipleAvalanches": "",
    "avalancheSize": "",
    "avalancheType": "",
    "relevantAvalancheProblem": "",
    "trigger": "",
    "natural": "",
    "person": "",
    "additionalLoad": "",
    "explosives": "",
    "vehicle": "",
    "accidentalControlled": "",
    "remoteTriggering": "",
    "startZoneAspect": "",
    "startZoneAspectAccuracy": "",
    "startZoneElevation": "",
    "startZoneElevationAccuracy": "",
    "startZoneIncline": "",
    "startZoneTerrainType": "",
    "slabWidth": "",
    "crownDepthAvg": "",
    "crownDepthMin": "",
    "crownDepthMax": "",
    "avalancheLength": "",
    "weakLayerName": "",
    "weakLayerGrainType1": "",
    "weakLayerGrainSize1": "",
    "weakLayerGrainType2": "",
    "weakLayerGrainSize2": "",
    "weakLayerLocation": "",
    "bedSurfaceStepped": "",
    "startZoneMoisture": "",
    "depositMoisture": "",
    "depositHeight": "",
    "depositWidth": "",
    "debrisType": "",
    "debrisDensity": "",
    "depositElevation": "",
    "avalancheDetailsComment": "",
    "incidentLedePublic": "",
    "incidentLede": "",
    "incidentDescriptionPublic": "",
    "incidentDescription": "",
    "weatherDescriptionPublic": "",
    "weatherDescription": "",
    "avalancheDescriptionPublic": "",
    "avalancheDescription": "",
    "snowpackDescriptionPublic": "",
    "snowpackDescription": "",
    "takeAwaysPublic": "",
    "takeAways": "",
    "recentSlabAvalanches": "",
    "signsOfInstability": "",
    "recentLoading": "",
    "criticalWarming": "",
    "incidentAnalysisComment": "",
    "uuid": "",
    "dateAdded": "",
    "dateCreated": "",
    "file": "",
    "fileName": "",
    "mediaType": "",
    "attachmentTags": "",
    "altText": "",
    "credit": "",
    "caption": "",
    "public": "",
    "attachmentCategory": ""
  },
  "sourceOfInformation": {
    "PublicObservation": "",
    "AWSInternal": "",
    "AWSObserver": "",
    "DispatchCentre": "",
    "Police": "",
    "MountainRescue": "",
    "Other": ""
  },
  "personInvolvement": {
    "Yes": "",
    "No": "",
    "Unknown": ""
  },
  "otherDamages": {
    "Yes": "Òc",
    "No": "Non"
  },
  "damagedAssets": {
    "Vehicle": "",
    "Forest": "",
    "Agriculture": "",
    "Livestock": "",
    "UtilitiesTechnicalInfrastructure": "",
    "ResidentialBuilding": "",
    "Other": ""
  },
  "timeAccuracy": {
    "exact": "exacte",
    "PT15M": "± 15 min",
    "PT30M": "± 30 min",
    "PT1H": "± 1 h",
    "PT2H": "± 2 h",
    "PT4H": "± 4 h",
    "PT6H": "± 6 h",
    "PT12H": "± 12 h",
    "P1D": "± 1 d",
    "P2D": "± 2 d",
    "P3D": "± 3 d",
    "unknown": "desconeishut"
  },
  "reportStatus": {
    "Draft": "",
    "Incomplete": "Incomplèt",
    "InReview": "",
    "Verified": ""
  },
  "locationAccuracy": {
    "exact": "exacte",
    "within15m": "± 15 m",
    "within30m": "± 30 m",
    "within100m": "± 100 m",
    "within250m": "± 250 m",
    "within500m": "± 500 m",
    "within1km": "± 1 km",
    "within2km": "± 2 km",
    "within5km": "± 5 km",
    "within10km": "± 10 km",
    "within20km": "± 20 km",
    "within50km": "± 50 km",
    "unknown": "desconeishut"
  },
  "groupType": {
    "RecreationalFamilyFriends": "",
    "Club": "",
    "Commercial": "",
    "Industrial": "",
    "Solo": "",
    "Unknown": "",
    "Other": ""
  },
  "groupSizeAccuracy": {
    "Exact": "",
    "Approximately": "",
    "AtLeast": "",
    "Unknown": ""
  },
  "incidentTerrainType": {
    "FreeTerrain": "",
    "ControlledTerrainOpen": "",
    "ControlledTerrainClosed": "",
    "Unknown": ""
  },
  "typeOfControlledTerrain": {
    "IndoorInsideBuilding": "",
    "Street": "",
    "TrainTrack": "",
    "SkiAreaResort": "",
    "CrossCountryTrack": "",
    "SledgingTrack": "",
    "Other": ""
  },
  "incidentActivity": {
    "Touring": "",
    "Freeriding": "",
    "SkiingSnowboarding": "",
    "Snowmobiling": "",
    "Mountaineering": "",
    "IceClimbing": "",
    "Snowshoeing": "",
    "HikingOnFoot": "",
    "CrossCountrySkiing": "",
    "HuntingFishing": "",
    "Sledging": "",
    "Snowbiking": "",
    "Biking": "",
    "InsideVehicle": "",
    "Unknown": "",
    "Other": ""
  },
  "travelDirection": {
    "Ascending": "",
    "Descending": "",
    "Stationary": "",
    "Traversing": "",
    "MovingOnPeaksRidges": "",
    "SnowmobileHighMarking": "",
    "CrossingRunouts": "",
    "Other": ""
  },
  "vehicleType": {
    "Car": "",
    "Bus": "",
    "SnowPlower": "",
    "Snowcat": "",
    "Other": ""
  },
  "avalancheGear": {
    "All": "Toti",
    "Some": "Quauques",
    "None": "Cap",
    "Unknown": ""
  },
  "natural": {
    "Natural": "",
    "CorniceFall": "",
    "Earthquake": "",
    "IceFall": "",
    "RockFall": ""
  },
  "person": {
    "PersonAccidental": "",
    "PersonControlled": ""
  },
  "explosives": {
    "Artillery": "",
    "CaseCharge": "",
    "CorniceControlledByExplosives": "",
    "HelicopterDeployedGasExploder": "",
    "HandThrownOrPlaced": "",
    "GasExploder": "",
    "HelicopterBomb": "",
    "Avalauncher": "",
    "PrePlacedRemotelyDetonated": "",
    "TramOrRopewayDelivery": "",
    "Other": ""
  },
  "vehicle": {
    "OverSnowVehicle": "",
    "Snowmobile": "",
    "Helicopter": "",
    "Other": ""
  },
  "startZoneElevationAccuracy": {
    "exact": "exacte",
    "within50m": "± 50 m",
    "within100m": "± 100 m",
    "within200m": "± 200 m",
    "unknown": "desconeishut"
  },
  "startZoneTerrainType": {
    "AlpineBowl": "",
    "Couloir": "",
    "NearRidgeCrest": "",
    "SparselyTreed": "",
    "OpenForest": "",
    "DenseForest": "",
    "ForestGlade": "",
    "Glacier": "",
    "OpenSlope": "",
    "Ridge": "",
    "ExtremeRockyTerrain": "",
    "BaseOfRockFace": "",
    "WoodPath": "",
    "LeewardSlope": "",
    "WindwardSlope": "",
    "IceWaterfall": "",
    "Other": ""
  },
  "weakLayerLocation": {
    "WithinNewSnow": "",
    "AtInterfaceWithOldSnow": "",
    "WithinOldSnowpack": "",
    "NearTheGround": ""
  },
  "debrisType": {
    "Fine": "",
    "Blocks": "",
    "Hard": "Dura",
    "Soft": "",
    "Rocks": "",
    "Trees": "",
    "Other": ""
  },
  "startZoneMoisture": {
    "Dry": "Shuta",
    "Moist": "",
    "Wet": "Umida",
    "Unknown": ""
  },
  "depositMoisture": {
    "Dry": "Shuta",
    "Moist": "",
    "Wet": "Umida"
  },
  "bedSurfaceStepped": {
    "Yes": "Òc",
    "No": "Non"
  },
  "multipleAvalanches": {
    "Yes": "Òc",
    "No": "Non"
  },
  "avalancheType": {
    "slab": "",
    "loose": "",
    "glide": "",
    "cornice": "",
    "unknown": ""
  },
  "avalancheSize": {
    "small": "",
    "small_medium": "",
    "medium": "",
    "medium_large": "",
    "large": "",
    "large_very_large": "",
    "very_large": "",
    "very_large_extreme": "",
    "extreme": "",
    "unknown": ""
  },
  "trigger": {
    "natural": "",
    "person": "",
    "explosives": "",
    "vehicle": "",
    "unknown": "",
    "Other": ""
  },
  "startZoneAspectAccuracy": {
    "Accurate": "",
    "Uncertain": ""
  },
  "remoteTriggering": {
    "Yes": "Òc",
    "No": "Non"
  },
  "additionalLoad": {
    "High": "",
    "Low": ""
  },
  "accidentalControlled": {
    "Accidental": "",
    "Controlled": ""
  },
  "caught": {
    "Involved": "",
    "NotInvolved": "",
    "Unknown": ""
  },
  "fatalInjured": {
    "Fatal": "",
    "Injured": "",
    "Uninjured": "",
    "Unknown": ""
  },
  "burialDegree": {
    "FullyBuried": "",
    "PartlyBuriedHeadCovered": "",
    "PartlyBuriedHeadUncovered": "",
    "PartlyBuried": "",
    "NotBuried": "",
    "Unknown": ""
  },
  "age": {
    "UpTo13": "≤ 13",
    "From14To20": "14–20",
    "From21To30": "21–30",
    "From31To40": "31–40",
    "From41To50": "41–50",
    "From51To60": "51–60",
    "From61To70": "61–70",
    "From71": "≥ 71"
  },
  "gender": {
    "Female": "",
    "Male": "",
    "Other": ""
  },
  "country": {
    "Austria": "Àustria",
    "Germany": "Alemania",
    "Italy": "Itàlia",
    "Switzerland": "Soïssa",
    "Other": ""
  },
  "workingAtTime": {
    "Yes": "Òc",
    "No": "Non"
  },
  "leaderAtTime": {
    "Yes": "Òc",
    "No": "Non"
  },
  "professionalCertification": {
    "None": "",
    "IFMGAGuide": "",
    "FullSkiGuide": "",
    "SkiInstructor": "",
    "ApprenticeGuide": "",
    "AvalancheProfessional": "",
    "AvalancheEducator": "",
    "Other": ""
  },
  "avalancheTraining": {
    "None": "Cap",
    "Awareness": "",
    "BasicREC": "",
    "AdvancedREC": "",
    "Professional": "",
    "Other": ""
  },
  "yearsActive": {
    "UpTo2Years": "",
    "From3To9Years": "",
    "From10Years": ""
  },
  "transceiver": {
    "NoTransceiver": "",
    "TransceiverOn": "",
    "TransceiverOff": ""
  },
  "shovel": {
    "Yes": "Òc",
    "No": "Non"
  },
  "probe": {
    "Yes": "Òc",
    "No": "Non"
  },
  "airbag": {
    "NoAirbag": "",
    "AirbagDeployed": "",
    "AirbagUndeployed": ""
  },
  "helmet": {
    "Yes": "Òc",
    "No": "Non"
  },
  "terrainTrap": {
    "None": "Cap",
    "Cliff": "",
    "Trees": "",
    "Gully": "",
    "Depression": "",
    "Bench": "",
    "Boulder": "",
    "CrevasseOrBergschrund": "",
    "Other": ""
  },
  "primaryLocationMethod": {
    "NotBuried": "",
    "SelfExtraction": "",
    "VisualClues": "",
    "TransceiverProbeShovel": "",
    "SpotProbing": "",
    "ProbeLine": "",
    "Recco": "",
    "RescueDog": "",
    "Snowmelt": "",
    "Other": ""
  },
  "rescuedBy": {
    "Self": "",
    "Companion": "",
    "OtherGroup": "",
    "OrganizedRescue": "",
    "Unknown": "",
    "Other": ""
  },
  "medicalIntervention": {
    "CPR": "",
    "ALS": "",
    "ECMO": "",
    "Other": ""
  },
  "estimatedTimeOfDeath": {
    "DuringTheAvalanche": "",
    "DuringBurial": "",
    "OnSiteAfterExtrication": "",
    "DuringTransport": "",
    "InHospital": ""
  },
  "causeOfDeath": {
    "Asphyxiation": "",
    "TraumaticInjury": "",
    "Hypothermia": "",
    "Other": ""
  },
  "respiratoryCavity": {
    "Yes": "Òc",
    "No": "Non"
  },
  "injurySeverity": {
    "Minor": "",
    "Moderate": "",
    "Major": ""
  },
  "recentSlabAvalanches": {
    "Present": "",
    "Absent": "",
    "Unknown": ""
  },
  "signsOfInstability": {
    "Present": "",
    "Absent": "",
    "Unknown": ""
  },
  "recentLoading": {
    "Present": "",
    "Absent": "",
    "Unknown": ""
  },
  "criticalWarming": {
    "Present": "",
    "Absent": "",
    "Unknown": ""
  },
  "attachmentTags": {
    "Picture": "",
    "PoliceReport": "",
    "MedicalReport": "",
    "Other": ""
  },
  "attachmentCategory": {
    "Incident": "",
    "Avalanche": "Lauet",
    "Snowpack": "Celh de nhèu",
    "Group": "",
    "Person": "",
    "Weather": "Temps atmosferic"
  }
}
